<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { getVersion, ApiError, type VersionInfo } from '@/api'
import { formatDate } from '@/admin/format'

const { t } = useI18n()
const version = ref<VersionInfo | null>(null)
const versionError = ref('')

async function loadVersion() {
  try {
    version.value = await getVersion()
  } catch (e) {
    versionError.value = e instanceof ApiError ? e.message : t('admin.loadVersionFailed')
  }
}

onMounted(loadVersion)
</script>

<template>
  <p v-if="versionError" class="error">{{ versionError }}</p>
  <dl v-else-if="version" class="info-card drill-card">
    <div class="field">
      <dt>{{ t('admin.version') }}</dt>
      <dd>{{ version.version }}</dd>
    </div>
    <div class="field">
      <dt>{{ t('admin.gitCommit') }}</dt>
      <dd>{{ version.git_commit }}</dd>
    </div>
    <div class="field">
      <dt>{{ t('admin.gitBranch') }}</dt>
      <dd>{{ version.git_branch }}</dd>
    </div>
    <div class="field">
      <dt>{{ t('admin.buildTime') }}</dt>
      <dd>{{ formatDate(version.build_time) }}</dd>
    </div>
  </dl>
</template>

<style scoped>
.info-card {
  margin: 0 0 1.5rem;
}

.error {
  color: var(--tg-destructive-text-color);
}
</style>
